import { RangeSlider } from 'client/widget-components';
import React, { memo } from 'react';
import { FilterItemProps, FilterTypes } from '../utils/types';
import { useFilterSortStyles } from '../utils/filterSortContext';
import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { inputsSelectors } from '../utils';

const { slider: sliderSelector } = inputsSelectors;
const DEFAULT_MIN_RANGE = 5;

function RangeFilterItem(props: FilterItemProps<FilterTypes.BETWEEN>) {
    const { item, currentValues, onChange } = props;
    const { min, max, displayPrice } = item.filtersData;
    const { sign, direction = 'ltr' } = extractPriceDirection(displayPrice);
    const { inputsStyle } = useFilterSortStyles();

    const onRangeValueChange = (selectedRange: {
        start: number;
        end: number;
    }) => {
        if (selectedRange.start === min && selectedRange.end === max) {
            onChange(undefined);
        } else {
            onChange(selectedRange);
        }
    };
    return (
        <RangeSlider
            min={min}
            max={max}
            currentValues={currentValues}
            onChange={onRangeValueChange}
            minRange={DEFAULT_MIN_RANGE}
            sign={sign}
            trackDataGrab={`${sliderSelector}${item.fieldId}`}
            labelsWrapperStyles={valuesDefaultStyles}
            labelStyles={[getLabelStyle(direction), inputsStyle?.inputLabel]}
            trackStyles={inputsStyle?.slider}
            data-auto={`range-slider-${item.fieldId}`}
        />
    );
}

const valuesDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '19px',
    },
};
function getLabelStyle(direction: 'ltr' | 'rtl') {
    return {
        [RuntimeMediaQuery.COMMON]: {
            display: 'flex',
            flexDirection: direction === 'rtl' ? 'row' : 'row-reverse',
        },
    } as ResponsiveStylesStructured;
}

function extractPriceDirection(displayPrice: string) {
    // extractPricePosition('$123.00'/'$123') => {direction: 'ltr', sign: '$'}
    // extractPricePosition('123.00€'/'123€') => {direction: 'rtl', sign: '€'}
    const result: { direction?: 'ltr' | 'rtl'; sign?: string } = {};
    const nonNumericSign = displayPrice.match(/[^\d.,]/);
    if (nonNumericSign === null) {
        return result;
    }
    const signChar = nonNumericSign[0];
    const signCharPos = displayPrice.indexOf(signChar);
    if (signCharPos === 0) {
        result.direction = 'ltr';
    } else if (signCharPos === displayPrice.length - 1) {
        result.direction = 'rtl';
    } else {
        return result;
    }
    result.sign = signChar;
    return result;
}
export default memo(RangeFilterItem);
